import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'

export class AccEntrySearchProvider extends AbstractProvider {
  urlPath = 'acc_entry_search_api'

  public search<T>(params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
